import { memo } from 'react';
import { useRouter } from 'next/router';

import { Box } from '@zillow/constellation-10';

import { useGetListingDetails } from '../../../../hooks/queries/properties';

import { REVIEW_PAGE_SECTIONS } from '../../../../constants/ListingDetailConstants';

import RecommendationsAlert from '../../../PostingPath/RecommendationsAlert';
import SpinnerContainer from '../../../SpinnerContainer';
import AirConditioningAmenities from './AirConditioningAmenities';
import FloorsAmenities from './FloorsAmenities';
import HeatingSystemsAmenities from './HeatingSystemsAmenities';
import LaundryAmenities from './LaundryAmenities';

type Props = {
  onRecsClick: (recommendationType: string) => void;
};

const KeyFeaturesContent = ({ onRecsClick }: Props): JSX.Element => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string;

  const { isPending: isListingDetailsPending } = useGetListingDetails(listingAlias);

  if (isListingDetailsPending) {
    return <SpinnerContainer />;
  }

  return (
    <>
      <RecommendationsAlert sectionName={REVIEW_PAGE_SECTIONS.KEY_FEATURES} onRecsClick={onRecsClick} />
      <Box
        data-testid="KeyFeaturesContent-Edit"
        css={{ display: 'flex', flexDirection: 'row', gap: '400', flexWrap: 'wrap' }}
      >
        <Box css={{ display: 'flex', flexDirection: 'column', gap: '400', flex: '1 0 280px' }}>
          <LaundryAmenities />

          <AirConditioningAmenities />
        </Box>

        <Box
          data-testid="KeyFeaturesFloorsContainer"
          css={{ display: 'flex', flexDirection: 'column', gap: '400', flex: '1 0 280px' }}
        >
          <FloorsAmenities />
        </Box>

        <Box css={{ display: 'flex', flexDirection: 'column', gap: '400', flex: '1 0 280px' }}>
          <HeatingSystemsAmenities />
        </Box>
      </Box>
    </>
  );
};

export default memo(KeyFeaturesContent);
